export default __webpack_public_path__ + "static/media/logo-sock.9457d255.png";